var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.signInFormVisible
      ? _c(
          "div",
          {
            staticClass: "border-box",
            staticStyle: {
              "min-width": "400px",
              width: "40vw",
              margin: "auto",
              "margin-top": "100px",
            },
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.statusInitial ||
                      _vm.statusInvoking ||
                      _vm.statusInvalid,
                    expression:
                      "statusInitial || statusInvoking || statusInvalid",
                  },
                ],
              },
              [
                _c("h3", { staticClass: "fg-color-blue" }, [
                  _vm._v("Sign in to TransparentChoice"),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("Email:")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inputEmail,
                          expression: "inputEmail",
                        },
                      ],
                      ref: "inputEmailRef",
                      staticClass: "form-control",
                      attrs: {
                        type: "email",
                        placeholder: "Email address",
                        autofocus: "",
                      },
                      domProps: { value: _vm.inputEmail },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.handleSignInCommandV1.apply(
                            null,
                            arguments
                          )
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.inputEmail = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("ValidationError", {
                      attrs: { context: "Email", errors: _vm.validationErrors },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Password:")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputPassword,
                        expression: "inputPassword",
                      },
                    ],
                    ref: "inputPasswordRef",
                    staticClass: "form-control",
                    attrs: { type: "password", placeholder: "Password" },
                    domProps: { value: _vm.inputPassword },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.handleSignInCommandV1.apply(null, arguments)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.inputPassword = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(0),
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.signinCommandEnabled,
                        expression: "signinCommandEnabled",
                      },
                    ],
                    staticClass: "btn btn-lg btn-primary btn-block",
                    on: {
                      click: _vm.handleSignInCommandV1,
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.handleSignInCommandV1.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Sign in")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.statusInvoking,
                        expression: "statusInvoking",
                      },
                    ],
                    staticClass: "btn btn-lg btn-primary btn-block",
                    attrs: { disabled: "" },
                  },
                  [_vm._v("Signing in...")]
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("hr"),
                _c("br"),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn btn-secondary btn-lg btn-block",
                    attrs: { href: "/#/organizations/users/sso" },
                  },
                  [_vm._v("Sign in with SSO")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.unableToAuthenticate,
                    expression: "unableToAuthenticate",
                  },
                ],
              },
              [
                _c("h3", { staticClass: "fg-color-blue" }, [
                  _vm._v("Unable to sign-in"),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("p", [_vm._v("There can be many reasons for this, eg.:")]),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-lg btn-primary btn-block",
                    on: { click: _vm.handleTryAgain },
                  },
                  [_vm._v("Try again")]
                ),
              ]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.signedInAlertVisible
      ? _c(
          "div",
          {
            staticClass: "border-box",
            staticStyle: {
              "min-width": "400px",
              width: "40vw",
              margin: "auto",
              "margin-top": "100px",
            },
          },
          [
            _c("h3", { staticClass: "fg-color-blue" }, [
              _vm._v("You are already signed in as " + _vm._s(_vm.email)),
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-lg btn-primary btn-block",
                on: {
                  click: function ($event) {
                    _vm.inputSignedInAsDifferentUser = true
                  },
                },
              },
              [_vm._v("Sign in as a different user")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-lg btn-secondary btn-block",
                attrs: { href: "/" },
              },
              [_vm._v("Go to my account")]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "text-right" }, [
      _c(
        "a",
        {
          staticClass: "text-dark",
          attrs: { href: "/#/organizations/users/requestresetpassword" },
        },
        [_vm._v("Forgot password?")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", [_c("div", { staticClass: "error" }, [_c("br")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("ul", [
      _c("li", [_vm._v("email and password mismatch")]),
      _vm._v(" "),
      _c("li", [_vm._v("typo or caps lock is enabled")]),
      _vm._v(" "),
      _c("li", [_vm._v("account does not exist")]),
      _vm._v(" "),
      _c("li", [_vm._v("no roles assigned")]),
      _vm._v(" "),
      _c("li", [_vm._v("account is locked (eg. due to inactivity)")]),
      _vm._v(" "),
      _c("li", [_vm._v("your access request is pending or was rejected")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _vm._v(
        "\n                Please check your email for any alerts. You can also request reset your password\n                "
      ),
      _c(
        "a",
        { attrs: { href: "/#/organizations/users/requestresetpassword" } },
        [_vm._v("here")]
      ),
      _vm._v(".\n            "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }